<template>
    <b-table ref="orderstable" selectable select-mode="single" sticky-header="56vh"
      @row-selected="$emit('row-selected', $event)" sort-icon-left :sort-by.sync="localSortBy"
      :sort-desc.sync="localSortDesc" :sort-compare="customSortBand" :items="itemsWithClasses" :fields="fields"
      :tbody-tr-class="getRowClass">
      <template #row-details>
        <!-- Пустой слот для row-details, чтобы активировать механизм слотов -->
      </template>
  
      <template #cell(id)="row">
        <span>
          {{ row.item.id }}
          <span v-if="!isPurchasedEarly(row.item.id) && isNewlyAdded(row.item.id)" class="new-cell-badge">
            NEW
          </span>
          <template v-if="isPurchasedEarly(row.item.id)">
            <br>
            <span class="smt2s">Valid till: {{ getCellValidDate(row.item.id) }}</span>
          </template>
        </span>
      </template>
  
      <template #cell(band)="row">
        <span v-if="!isComplexProduct(row.item.id)" class="small-gray-card">
          {{ getBandName(getCellById(row.item.id)?.usageBand ?? 1) }}
        </span>
        <span v-else class="small-cyan-card">
          {{ $t("route.multiple") }}
        </span>
      </template>
  
      <template #cell(price)="row">
        {{ getCellDisplayPrice(row.item.id) }}
      </template>
  
      <template #cell(selected)="row">
        <b-checkbox switch :checked="!row.item.disabled" @change="$emit('toggle-cell-inclusion', row.item.id)" />
      </template>
    </b-table>
</template>

<script>
export default {
  name: 'CartTable',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      required: true
    },
    sortBy: {
      type: String,
      default: null
    },
    sortDesc: {
      type: Boolean,
      default: false
    },

    // Функции из родительского компонента
    isPurchasedEarly: {
      type: Function,
      required: true
    },
    getCellValidDate: {
      type: Function,
      required: true
    },
    isNewlyAdded: {
      type: Function,
      required: true
    },
    isComplexProduct: {
      type: Function,
      required: true
    },
    getBandName: {
      type: Function,
      required: true
    },
    getCellById: {
      type: Function,
      required: true
    },
    getCellDisplayPrice: {
      type: Function,
      required: true
    },
  },
  computed: {
    // Добавляем класс к каждому элементу
    itemsWithClasses() {
      return this.items.map(item => ({
        ...item,
        _rowVariant: this.isPurchasedEarly(item.id) ? 'success' : null
      }));
    },

    localSortBy: {
      get() { return this.sortBy; },
      set(value) { this.$emit('update:sortBy', value); }
    },

    localSortDesc: {
      get() { return this.sortDesc; },
      set(value) { this.$emit('update:sortDesc', value); }
    }
  },
  methods: {
    // Функция для определения класса строки
    getRowClass(item, type) {
      console.log("CartTable: getRowClass called for item", item?.id, "type", type, "isPurchased:", this.isPurchasedEarly(item?.id));
      if (type === 'row' && this.isPurchasedEarly(item?.id)) {
        console.log("Returning purchased-row class");
        return 'purchased-row';
      }
      return '';
    },

    customSortBand(a, b, isDesc) {
      // Сортировка по usageBand (третий символ id как число)
      const bandA = parseInt(a.id?.charAt(2), 10) || 0;
      const bandB = parseInt(b.id?.charAt(2), 10) || 0;
      if (bandA < bandB) return isDesc ? 1 : -1;
      if (bandA > bandB) return isDesc ? -1 : 1;
      return 0;
    },

    // Метод для программного выбора строки
    selectRow(index) {
      if (this.$refs.orderstable) {
        this.$refs.orderstable.selectRow(index);
      }
    }
  }
}
</script>

<style scoped>
/* Слабый зеленый фон для купленных ранее */
.purchased-row {
  background-color: #eafbe7 !important;
}

/* BootstrapVue row variant success */
.table-success,
.table-success>th,
.table-success>td {
  background-color: #eafbe7 !important;
}

.table-success:hover,
.table-success:hover>th,
.table-success:hover>td {
  background-color: #d4f4d0 !important;
}

.small-gray-card {
  display: inline-block;
  padding: 2px 6px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 0.75rem;
  color: #495057;
  font-weight: 500;
}

.small-cyan-card {
  display: inline-block;
  padding: 2px 6px;
  background-color: #e0f7ff;
  border: 1px solid #17a2b8;
  border-radius: 4px;
  font-size: 0.75rem;
  color: #0c5460;
  font-weight: 500;
}

.smt2s {
  font-size: 0.7rem;
  color: #6c757d;
  font-weight: normal;
}

.small-black {
  color: #212529;
  font-size: 0.875rem;
}

.small-gray {
  color: #6c757d;
  font-size: 0.875rem;
  background-color: #f8f9fa;
}

/* Анимация для новых ячеек */
.newly-added-cell {
  background-color: #d4edda !important;
  border-left: 4px solid #28a745 !important;
  animation: newCellPulse 3s ease-in-out;
  transition: all 0.3s ease;
}

@keyframes newCellPulse {
  0% {
    background-color: #28a745;
    transform: scale(1.02);
  }

  15% {
    background-color: #d4edda;
    transform: scale(1);
  }

  100% {
    background-color: #d4edda;
  }
}

.new-cell-badge {
  background-color: #28a745;
  color: white;
  font-size: 0.7rem;
  padding: 2px 6px;
  border-radius: 12px;
  margin-left: 5px;
  animation: badgeFadeIn 0.3s ease-in;
}

@keyframes badgeFadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Плавное появление строк */
.table-row-enter-active {
  transition: all 0.3s ease;
}

.table-row-enter {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
